module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/project-type-1-a98719ba0324b77d1caff341adbd6c3e.svg";